import React, { FunctionComponent } from 'react';

import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { useReview } from 'reviews2/feed/review-yeti/Review.store';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/date/ReviewDate.scss';

export const ReviewDate: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const { review } = context;
    const [{ isNorthStarEnabled }] = useReview();

    if (!review) {
        return null;
    }

    return (
        <div className="r4e-review-date">
            {isNorthStarEnabled
                ? t('REVIEWED_ON', {
                      reviewDate: DateTime.fromISO(review.post_created_at!).toLocaleString(DateTime.DATE_FULL),
                  })
                : DateTime.fromISO(review.post_created_at!).toLocaleString(DateTime.DATE_MED)}
        </div>
    );

    return <></>;
};
